import React, { useEffect, useState } from 'react';
import { IFreePluginProgressBar, initFreePluginProgressBar } from '../../domain/free-plugin-provider';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import { isEqual } from 'lodash';
import TermsAndConditions from '../shared/terms-and-conditions';
import { ICartData } from '../../interfaces';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-5070
 */

export const checkIfProgessBarEnabled = (
    cartData: ICartData,
) : boolean => {
    if(!cartData) return false;
    return initFreePluginProgressBar(cartData)?.enabled ?? false;
};

interface IFreePluginProgressBarProps {
    cartData: ICartData;
    classes?: string;
}

const FreePluginProgressBar = ({ classes, cartData }: IFreePluginProgressBarProps) => {

    const [progressBar, setProgressBar] = useState<IFreePluginProgressBar|null>(null);
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        if(!cartData) return;

        const data = initFreePluginProgressBar(cartData);
        setEnabled(data?.enabled ?? false);

        if(!data.enabled || isEqual(data, progressBar)) return;

        // show progress bar ----
        setProgressBar(data);
    }, [
        cartData,
        progressBar,
    ]);

    return (
        <>
            {
                enabled && progressBar &&
                <div className={ `w-full mt-3 ${ classes ?? '' }` }>

                    <div
                        role="progressbar"
                        aria-labelledby="free-plugin-progress-label"
                        aria-valuemin={ progressBar.min }
                        aria-valuemax={ progressBar.max }
                        aria-valuenow={ progressBar.value }
                        aria-valuetext={ progressBar.ariaText }
                        className="w-full border border-green rounded bg-green-100"
                    >
                        <div
                            className="h-full bg-green"
                            style={{
                                width: `${ progressBar.percent }%`,
                                height: '5px',
                            }}
                        />
                    </div>

                   <div className="flex items-center justify-between gap-2 mt-2 md:whitespace-nowrap flex-wrap md:flex-nowrap">
                       <div
                           id="free-plugin-progress-label"
                           className="text-sm">

                           {
                               progressBar.label?.type === 'amount' &&
                               <>
                                   Add <ProductPriceFormat price={ progressBar.label.missingAmount } /> to get <strong className="font-bold">{ progressBar.label.receiveCount } FREE plugin{ progressBar.label.receiveCount === 1 ? '' : 's' }</strong>
                               </>
                           }

                           {
                               progressBar.label?.type === 'count' &&
                               <>
                                   Add { progressBar.label.missingCount } more plugin{ progressBar.label.missingCount === 1 ? '' : 's' }, get <strong className="font-bold">{ progressBar.label.receiveCount } FREE plugin{ progressBar.label.receiveCount === 1 ? '' : 's' }</strong>
                               </>
                           }

                       </div>

                       <TermsAndConditions
                           url={ cartData.efstcurl }
                           classes="md:ml-auto block"
                           styles={{
                               lineHeight: '1',
                               marginTop: '1px',
                           }}
                       />
                   </div>
                </div>
            }
        </>
    )
};

export default FreePluginProgressBar;